// <- UnlockRequest.js
import React, { useState, useEffect, Fragment } from "react";
import { Button, Input, Row, Col, Form } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import Notifications from "../../../components/common/Notifications";
import moment from "moment";
import api from "../../../apis/api";
import { getMinAllowedDate, isDateAllowed } from "../../../config/unlockConfig";

const loginUser = JSON.parse(localStorage.getItem("user"));

const UnlockRequest = React.memo(
  ({
    
    handleClsUnlockTaskForm,
    handleUnlockRequest,
    setIsOpenAddEditForm,
    handlecloseUnlock,
    projectId,
    unlockReqList
  }) => {
    // Get the minimum allowed date from global config
    const [dynamicMinLockDate, setDynamicMinLockDate] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1));

    useEffect(() => {
      const fetchMinLockDate = async () => {
        try {
          const response = await api.dbAutoLOPConfig().GetLockedDateRange();
          if (response?.data?.success && response.data.maxLockedDate) {
            setDynamicMinLockDate(new Date(response.data.maxLockedDate));
          }
        } catch (err) {
          console.error("Error fetching lock dates for UnlockRequest:", err);
        }
      };
      fetchMinLockDate();
    }, []);

    const dynamicMinDate = dynamicMinLockDate;
    
    // Calculate maxDate as the last Friday of the current week
    const getLastFriday = () => {
      const today = new Date();
      const dayOfWeek = today.getDay();
      // Friday is day 5
      let daysUntilFriday = 5 - dayOfWeek;
      if (daysUntilFriday <= 0) {
        // If today is Friday or past Friday, get next week's Friday
        daysUntilFriday += 7;
      }
      const lastFriday = new Date(today);
      lastFriday.setDate(today.getDate() + daysUntilFriday);
      return lastFriday;
    };
    const lastFridayl = getLastFriday();
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [summary, setSummary] = useState("");
    const [reason, setReason] = useState("");
    const [error, setError] = useState(null);
useEffect(() =>{
  let be=projectId;
  setFromDate(new Date());
  setToDate(new Date());
  setSummary("");
  setReason("");
},[projectId])
    // Functions.
    // handle change date in DOJ
    const handleChangeStartDate = (date) => {
      if (unlockReqList.some(e => e ===moment(date).format("YYYY-MM-DD"))) {

        setError({ ...error, message: "Request already sent..", status: 500 });
        setFromDate(new Date());
      }

      else
      {
        setFromDate(date);
      }
      
    };
    function getDatesInRange(startDate, endDate) {
      const date =new Date(startDate);
    const enddate=new Date(endDate)
      const dates = [];
    
      while (date <= enddate) {
        dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
        date.setDate(date.getDate() + 1);
      }
    
      return dates;
    }
    const handleChangeEndDate = (date) => {
      if(moment(fromDate).format("YYYY-MM-DD") <= moment(date).format("YYYY-MM-DD") )
        {
          var daterange=[];
          daterange=getDatesInRange(moment(fromDate).format("YYYY-MM-DD"), moment(date).format("YYYY-MM-DD"));
       let result=0;
          const set1 = new Set(unlockReqList);
          const set2 = new Set(daterange);
      
          for (let date of set1) {
            if (set2.has(date)) {
              result=1;
            }
          }
          
          if (result == 1) {

            setError({ ...error, message: "Request already sent..", status: 500 });
            setToDate(new Date());
          }
    
          else
          {
            setToDate(date);
          }
          
        }
        else
        {
          setError({ ...error, message: "To Date Must Be Greater Than From Date..", status: 500 });
          setToDate(new Date());
        }
      
      
      
    };
    

    const inputDateFormatString = (workDate)=>{
      var year = workDate.getFullYear();
      var month = workDate.getMonth() + 1;
      if(month <= 9)
          month = '0'+month;
      var day= workDate.getDate();
      if(day <= 9)
          day = '0'+day;
          var prettyDate = year +'-'+ month +'-'+ day;
          return prettyDate;
    };

    // handle form submite.
    const handleSubmitForm = (e) => {
  e.preventDefault();

  // validation
  if (!summary || summary.trim() === "") {
    setError({ ...error, message: "Summary is required.", status: 500 });
    return;
  }

  if (!fromDate) {
    setError({ ...error, message: "From Date is required.", status: 500 });
    return;
  }

  if (!toDate) {
    setError({ ...error, message: "To Date is required.", status: 500 });
    return;
  }

  if (!reason || reason.trim() === "") {
    setError({ ...error, message: "Reason is required.", status: 500 });
    return;
  }

  // clear any previous errors
  setError(null);

  let formDate = {
    employeeId: parseInt(loginUser.EmployeeId),
    fromDate: inputDateFormatString(fromDate),
    toDate: inputDateFormatString(toDate),
    summary: summary,
    reason: reason,
    Status: 1,
  };

  handlecancelbutton();
  handleUnlockRequest(formDate, e);
};
    const handlecancelbuttonTop =() =>{
      setSummary("");
      setReason("");
      setFromDate(new Date());
      setToDate(new Date());
      handlecloseUnlock();
     
    }
    const handlecancelbutton =() =>{
      setSummary("");
      setReason("");
      setFromDate(new Date());
      setToDate(new Date());
      handlecloseUnlock();
      // handleClsUnlockTaskForm();
    }
    
    return (
      <Fragment>
        <Form>
          <div className="fixed-header">
            <div>
            <h6>Timesheet Unlock Request</h6>
            </div>
            <div className="d-inline float-right " style={{marginTop: "-33px"}}>
                <Button color="" onClick={() =>handlecancelbuttonTop()}>
                  <i className="fas fa-times text-muted"></i>
                </Button>
              </div>
          </div>
          
          <div className="task-details">
            <div className="chat-wrap-inner" style={{minHeight : "53vh"}}>             
              <div className="chats">             
                <Input
                  type="text"
                  placeholder="Summary"
                  onChange={(e) => setSummary(e.target.value)}
                  value={summary}
                />
                <br/>
                <div className="task-header">
                <div className="task-due-date">
                    <div className="due-icon">
                      <span>
                        <i className="fas fa-calendar-alt text-muted"></i>
                      </span>
                    </div>
                    <div className="due-info">
                      <div className="task-head-title">From Date</div>
                      <div className="due-date">
                        <DatePicker
                          selected={fromDate}
                          onChange={handleChangeStartDate}
                          dateFormat="dd-MM-yyyy"
                           minDate={dynamicMinDate}
        
                          // maxDate={lastFridayl}
                          filterDate={isDateAllowed}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="task-due-date">
                    <div className="due-icon">
                      <span>
                        <i className="fas fa-calendar-alt text-muted"></i>
                      </span>
                    </div>
                    <div className="due-info">
                      <div className="task-head-title">To Date</div>
                      <div className="due-date">
                        <DatePicker
                          selected={toDate}
                          onChange={handleChangeEndDate}
                          dateFormat="dd-MM-yyyy"
                           minDate={fromDate || dynamicMinDate}
          
                          // maxDate={lastFridayl}
                          filterDate={isDateAllowed}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="task-data ">                  
                  <div className="p-2 ">
                    <span className="description-title">Reason</span>
                    <span className="description w-100">
                      <Input
                        type="textarea"
                        onChange={(e) => setReason(e.target.value)}
                        value={reason}
                      />
                    </span>
                  </div>
                  <Row>
                    <Col className="text-center mt-2">
                      <Button
                        type="submit"
                        color=""
                        className="btn-admin-settings"
                        onClick={handleSubmitForm}
                      >
                      Submit
                      </Button>
                      &nbsp;
                      <Button
                        color=""
                        className="btn-cancel"
                        onClick={handlecancelbutton}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <Notifications notifications={error}></Notifications>
        </Form>
      </Fragment>
    );
  }
);
export default UnlockRequest;
